@if (!disableHeader) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button (click)="closePopup()"></ion-menu-button>
      </ion-buttons>
      <ion-title style="font-size: 13px;">
        <div class="titleBar">
          {{ title  | translate }}
          @if (NotificationService.showNotificationBell) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">
                <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                <!--<app-app-icon [icon]="bellIcon" id="bellsize"></app-app-icon>-->
                <!--<img class="bellsize" src="../../../../assets/icon/notification/bell.png" alt="">-->
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
}
<!-- Top ones are the offers so rememebr -->
<ion-content class="content-theme-one">
  @if ((mobile && !settingService.navigationSetting) && settingService.configuration.uIoptions) {
    <app-undocked-navigation-bar style="position: relative; z-index: 10;" [disabledOption]="title"></app-undocked-navigation-bar>
  }

  <div [ngClass]="{ 'content-push-up': isPopup }">
    @if (offers && offers.length>0) {
      <div class="offer-cards" [ngClass]="{'addPadding-Inline': displayValidation() == 1, 'addPadding-NoUndock-Inline': displayValidation() == 2, 'Popup-sizing': displayValidation() == 3}">
        @for (offer of offers; track offer) {
          <ion-card padding [ngClass]="{'disable-background-color': !this.settingService.UIshowBackground}" class="offerCards" (click)="onOfferClicked(offer)" style="margin:7px; ">
            <ion-grid>
              <!-- <ion-row>
              <ion-col class="img-col" size="auto">
                <img class="offer-img" *ngIf="getOfferImage(offer)" [src]="getOfferImage(offer)">
              </ion-col>
              <ion-col  size="auto">
                <ion-grid class="offer-information">
                  <ion-row>
                    <ion-col class="item-name" col-12 *ngFor="let item of offer.Choices">
                      <ion-badge>
                        {{ getItemDescription(item) }}
                      </ion-badge>
                    </ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col>
                      {{ 'Offer.Expire' | translate }}
                      {{ offer.ExpirationDate }}
                      {{ 'OFFER.EXPIRE_THE' | translate }}
                      {{ offer.ExpirationDate | date : 'dd MMMM, yyyy'}}
                      {{ 'GENERAL.AT' | translate }}
                      {{ offer.ExpirationDate | date : 'HH:mm'}}
                    </ion-row>
                    <ion-row>
                      <ion-col>Restaurant: {{offer.LocationName}}</ion-col>
                    </ion-row>
                  </ion-grid>
                </ion-col>
              </ion-row> -->
              <ion-row>
                <!--
                <ion-col class="responsiveMargin" size="auto" style="background: var(--ion-color-primary, #3880ff);" >
                  <div style="width: 10px"></div>
                </ion-col>
                -->
                <ion-col style="padding-top: 0px;">
                  <div style="display: flex; ">
                    <!-- <div style="display: flex;  width: 50%; padding: 28px; justify-content: center;"> -->
                    <div class="coupon-img">
                      @if (getOfferImage(offer)) {
                        <img class="offer-img" [src]="getOfferImage(offer)">
                      }
                    </div>
                  <!-- </div> -->
                  <div class="couponCol">
                    <div style="height: 80%; display: flex;">
                      <span class="offerAmount" >{{offer.LocationName}}</span>
                    </div>
                    <div  class="couponType">{{offer.ExpirationDate}}</div>
                  </div>
                </div>
                @for (item of offer.Choices; track item) {
                  <div class="couponName"> {{ getItemDescription(item) }}</div>
                }
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card>
      }
    </div>
  }

  @if (coupons.length>0 && coupons) {
    <div class="coupon-cards" [ngClass]="{'addPadding-Inline': displayValidation() == 1, 'addPadding-NoUndock-Inline': displayValidation() == 2, 'Popup-sizing': displayValidation() == 3}">
      @for (coupon of coupons; track coupon) {
        <ion-card [ngClass]="{'disable-background-color': !this.settingService.UIshowBackground}" class="couponCards" style="margin-left: 0;border-radius: none; margin:7px;"  id="test" (click)="goView(coupon.Id)">
          <ion-grid>
            <ion-row>
              <!--
              <ion-col class="responsiveMargin" size="auto" style="background: var(--ion-color-primary, #3880ff);" >
                <div style="width: 10px"></div>
              </ion-col>
              -->
              <ion-col style="padding-top: 0px;">
                <div style="display: flex; ">
                  <!-- <div style="display: flex;  width: 50%; padding: 28px; justify-content: center;"> -->
                  <div class="coupon-img">
                    @if (coupon.ImageUrl) {
                      <img class="offer-img" [src]="coupon.ImageUrl">
                    }
                  </div>
                <!-- </div> -->
                <div class="couponCol">
                  <!-- <div style="font-size: 1.2rem; margin: auto;">12$  <div>Discount</div> </div> -->
                  <div class="couponAmountContainer">
                    <!-- <div style="text-align: center; margin: auto; font-size: 2.7rem; font-weight: bold; color: var(--ion-color-primary-contrast)">12%</div> -->
                    <span class="couponAmount">{{coupon.Amount}}@if (coupon.Type === couponsType.DOLLAR) {
                      $
                      }@if (coupon.Type=== couponsType.PERCENT) {
                      %
                    }</span>
                  </div>
                  @if (coupon.Type=== couponsType.PERCENT) {
                    <div   class="couponType">{{ 'Coupon.Discount2' | translate }}</div>
                  }
                  @if (coupon.Type === couponsType.DOLLAR) {
                    <div class="couponType">{{ 'Coupon.Rebate' | translate }}</div>
                  }
                  @if (coupon.Type ===  couponsType.REWARD_FIX || coupon.Type ===  couponsType.REWARD_RATIO) {
                    <div class="couponType">{{ 'Coupon.Bonus' | translate }}</div>
                  }
                </div>
              </div>
              <div class="couponName" >{{getCouponTranslationName(coupon.Translations)}}</div>
            </ion-col>
            <!-- <ion-col size="auto" class="imageCol">
            <img class="offer-img" *ngIf="coupon.ImageUrl" [src]="coupon.ImageUrl">
          </ion-col> -->
          <!-- <ion-col  style="background:  var(--ion-color-primary, #3880ff); display: flex; flex-direction: column;"> -->
          <!-- <ion-grid class="coupon-information">
          <ion-row>
            <ion-col>
              <ion-badge>{{getCouponTranslationName(coupon.Translations)}}</ion-badge>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col >
              {{ 'Offer.ExpireThe' | translate }}
              {{ coupon.ExpirationDate | date : 'dd MMMM, yyyy' }}
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>{{'Coupon.Discount' | translate}} {{coupon.Amount}}<ng-container *ngIf="coupon.Type==2">$</ng-container><ng-container *ngIf="coupon.Type==1">%</ng-container></ion-col>
          </ion-row>
        </ion-grid> -->
        <!-- <div style="text-align: center; margin: auto; color: white; font-weight: bold; font-size: 3rem;">{{coupon.Amount}}<ng-container *ngIf="coupon.Type==2">$</ng-container><ng-container *ngIf="coupon.Type==1">%</ng-container></div>
        <div style="text-align: center; margin: auto; color: white; font-weight: bold; font-size: 1.5rem;">Discount</div> -->
        <!-- {{'Coupon.Discount' | translate}} {{coupon.Amount}}<ng-container *ngIf="coupon.Type==2">$</ng-container><ng-container *ngIf="coupon.Type==1">%</ng-container> -->
      <!-- </ion-col> -->
    </ion-row>
  </ion-grid>
</ion-card>
}
</div>
}


<!--This is for the promotions-->
@if (promotions.length > 0 && promotions) {
  <div class="promo-cards" [ngClass]="{'addPadding-Inline': displayValidation() == 1, 'addPadding-NoUndock-Inline': displayValidation() == 2, 'Popup-sizing': displayValidation() == 3}">
    @for (promotion of promotions; track promotion) {
      <ion-card [ngClass]="{'disable-background-color': !this.settingService.UIshowBackground}" class="promoCards" style="margin-left: 0;border-radius: none; margin:7px;"  id="test" >
        @if (validatePresentation(promotion)) {
          <div class="promoCards" (click)="goViewPromo(promotion)">
            <ion-grid style="padding: 0px">
              <ion-row>
                <ion-col style="padding: 2px !important; ">
                  <div style="display: flex; ">
                    <div class="promo-img">
                      @if (promotion.visualConfig.imgURL && !this.mobile) {
                        <img class="promo-img" [src]="getpromoImage(promotion)">
                      }
                      @if (promotion.visualConfig.imgMobileURL && this.mobile) {
                        <img class="promo-img" [src]="getpromoImage(promotion)">
                      }
                    </div>
                    <!--
                    <div class="couponCol">
                      <div style="height: 80%; display: flex;">
                        <span class="couponAmount">{{promotion.discountDetails.discountValue}}<ng-container  *ngIf="promotion.discountDetails.discountType == 'DOLLAR'">$</ng-container><ng-container *ngIf="promotion.discountDetails.discountType == 'PERCENT'">%</ng-container></span>
                      </div>
                      <div   *ngIf="promotion.discountDetails.discountType === 'PERCENT'" class="couponType">{{ 'Coupon.Discount2' | translate }}</div>
                      <div *ngIf="promotion.discountDetails.discountType == 'DOLLAR'" class="couponType">{{ 'Coupon.Rebate' | translate }}</div>
                    </div>
                    -->
                  </div>
                  <!--<div class="couponName" >{{getCouponTranslationName(coupon.Translations)}}</div>-->
                  <!--<div class="couponName" >{{promotion.promotionName}}</div>-->
                </ion-col>
              </ion-row>
            </ion-grid>
          </div>
        }
      </ion-card>
    }
  </div>
}

@if (coupons.length==0 && offers.length==0) {
  <ion-card padding [ngClass]="{'disable-background-color': !this.settingService.UIshowBackground}"  class="full-width no-coupons" style="margin:10px;">
    <div>{{'Coupon.NoCoupons' | translate}}</div>
  </ion-card>
}

<!-- <ion-card *ngIf="(!coupons || coupons.length < 1) && (!offers || offers.length < 1)"
style="text-align:center;border-radius: none;padding-top: 10px;padding-bottom: 10px; margin:10px;">
<h4 style="padding: 10px">{{ 'Offer.NoOffersAvailable' | translate }}</h4>
</ion-card> -->
</div>

</ion-content>
